import { Col, Row } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";

const MediaCard = ({ label, path }) => {
  const url = getJeepRallyMediaUrl(path);

  return (
    <div className="mb-3">
      <div className="text-muted small mb-2">{label}</div>
      {url ? (
        <img
          src={url}
          alt={label}
          style={{
            width: "100%",
            maxHeight: "220px",
            objectFit: "cover",
            borderRadius: "8px",
            border: "1px solid #dee2e6",
          }}
        />
      ) : (
        <div className="text-muted">No image uploaded</div>
      )}
    </div>
  );
};

const RallyMediaSection = ({ rally }) => {
  return (
    <div className="mb-4">
      <h5 className="mb-3">Media</h5>
      <Row>
        <Col md={6}>
          <MediaCard label="Banner" path={rally?.banner_image} />
        </Col>
        <Col md={6}>
          <MediaCard label="Thumbnail" path={rally?.thumbnail_image} />
        </Col>
      </Row>
    </div>
  );
};

export default RallyMediaSection;
